module.exports = __webpack_public_path__ + "sr.svg?64fb37b49bdd1d10f833926e24da7226";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/sr.svg
// module id = 1367
// module chunks = 0